/* tslint:disable */
/* tslint:disable */
/**
 * ClearFlask Admin API
 * ClearFlask API documentation.
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/* tslint:disable */
// eslint-disable-next-line no-unused-vars
import { exists } from '../runtime';
// eslint-disable-next-line no-unused-vars
import {
    Hits,
    HitsFromJSON,
    HitsToJSON,
    UserAdmin,
    UserAdminFromJSON,
    UserAdminToJSON,
} from './';

/**
 * 
 * @export
 * @interface UserSearchResponse
 */
export interface UserSearchResponse {
    /**
     * Cursor to fetch next set of results.
     * @type {string}
     * @memberof UserSearchResponse
     */
    cursor?: string;
    /**
     * 
     * @type {Array<UserAdmin>}
     * @memberof UserSearchResponse
     */
    results: Array<UserAdmin>;
    /**
     * 
     * @type {Hits}
     * @memberof UserSearchResponse
     */
    hits?: Hits;
}

export function UserSearchResponseFromJSON(json: any): UserSearchResponse {
    return {
        'cursor': !exists(json, 'cursor') ? undefined : json['cursor'],
        
        'results': (json['results'] as Array<any>).map(UserAdminFromJSON),
        
        
        'hits': !exists(json, 'hits') ? undefined : HitsFromJSON(json['hits']),
    };
}

export function UserSearchResponseToJSON(value?: UserSearchResponse): any {
    if (value === undefined) {
        return undefined;
    }
    return {
        'cursor': value.cursor,
        
        'results': (value.results as Array<any>).map(UserAdminToJSON),
        
        
        'hits': HitsToJSON(value.hits),
    };
}


